import currencySelectorComponentUrl from './currencySelectorComponent.html';
class CurrencySelectorController {
  constructor(CurrencyService, Utils, focus, $scope) {
    'ngInject';

    Object.assign(this, { CurrencyService, Utils, focus, $scope });
  }

  $onInit() {
    this.defaultCurrencies = this.CurrencyService.getDefaultCurrencies();
    this.currencies = this.defaultCurrencies;
    this.onlyDefault = true;

    this.$scope.$watch('ctrl.dropdownOpened', () => {
      if (!this.dropdownOpened) {
        this.currencies = this.defaultCurrencies;
        this.onlyDefault = true;
      }
    });
  }

  async loadFullList($event) {
    $event.stopPropagation();
    this.currenciesLoading = true;

    try {
      this.currencies = await this.CurrencyService.getAllCurrencies();
      this.onlyDefault = false;
    } finally {
      this.currenciesLoading = false;
    }
  }

  select(currency) {
    this.selectedCurrency = currency;
    this.currencyForm.$setDirty();
  }
}

export default {
  templateUrl: currencySelectorComponentUrl,
  controller: CurrencySelectorController,
  controllerAs: 'ctrl',
  bindings: {
    selectedCurrency: '=',
  },
};
